import React, { useState } from 'react'

import styled from 'styled-components'

import { RxCross1 } from 'react-icons/rx'

import P from '../../typography/P'

const status = {
  1: 'Beginner',
  2: 'Novice',
  3: 'Skilled',
  4: 'Experienced',
  5: 'Expert',
}

const SkillRangeSlider = ({
  skill,
  experience,
  id,
  setSkills,
  skills,
  readOnly = false,
}) => {
  const [value, setValue] = useState(experience)
  const [style, setStyle] = useState(status[experience])

  const handleUpdateSkillExperience = (e) => {
    const newSkill = {
      label: skill,
      experience: e,
      value: id,
    }

    const index = skills.findIndex((skill) => skill.value === id)
    const updatedSkills = skills
    updatedSkills.splice(index, 1, newSkill)

    setValue(e)
    setSkills(updatedSkills)
    setStyle(status[e])
  }

  const handleDeleteSkillExperience = (id) => {
    const filtered = skills.filter((e) => e.value !== id)
    setSkills(filtered)
  }

  return (
    <SkillRangeSliderContainer>
      <div className="details">
        {!readOnly && (
          <RxCross1
            onClick={() => !readOnly && handleDeleteSkillExperience(id)}
            className="icon"
          />
        )}

        <P size="0.875rem">{skill}</P>
      </div>

      <div className="slider">
        <p>{style}</p>
        <input
          onChange={(e) => {
            !readOnly && handleUpdateSkillExperience(parseInt(e.target.value))
          }}
          value={value}
          className={`slider ${style}`}
          type="range"
          min="1"
          max="5"
        />
      </div>
    </SkillRangeSliderContainer>
  )
}

export default SkillRangeSlider

const SkillRangeSliderContainer = styled.div`
  width: 100%;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eaeaf8;
  gap: 0.5rem;

  .details {
    display: flex;
    align-items: center;
    width: 100%;

    .icon {
      font-size: 1rem;
      margin-right: 0.5rem;
      color: #acb2cc;
      cursor: pointer;
    }
  }

  .slider {
    width: 100%;
    max-width: 318px;
    cursor: pointer;

    p {
      font-size: 0.625rem;
      font-weight: 500;
      color: #acb2cc;
    }

    .slider {
      width: 100%;
      height: 2px;
      -webkit-appearance: none;
      outline: none;
      border: none;
      background: linear-gradient(
        90deg,
        #e4f79c -1.65%,
        #cae463 23.76%,
        #a2dd74 49.71%,
        #7dd585 76.18%,
        #5cca95 100%
      );
      border-radius: 100px;
      transition: all 0.3s ease-in-out;

      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 0.875rem;
        height: 0.875rem;
        border-radius: 50%;
        background: #ddf382;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
      }

      &.Novice {
        &::-webkit-slider-thumb {
          background: #cae463;
        }
      }

      &.Skilled {
        &::-webkit-slider-thumb {
          background: #a2dd74;
        }
      }

      &.Experienced {
        &::-webkit-slider-thumb {
          background: #7dd585;
        }
      }

      &.Expert {
        &::-webkit-slider-thumb {
          background: #5cca95;
          box-shadow: 0px 0px 0px 12px rgba(92, 202, 149, 0.2);
        }
      }
    }
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    border-bottom: none;
  }
`
